export default "__VITE_ASSET__C8Ucj9dE__"